import API, { handleRequest } from '../lib/api'

const withParams = (params = {}) => ({
  params: Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  ),
})

export const getAllDelivaryCondation = (restaurant_id, params = {}) =>
  handleRequest(() =>
    API.get(`restaurant/${restaurant_id}/delivery-conditions`, withParams(params))
  )

export const findDelivaryPostcodes = (restaurant_id, params = {}) =>
  handleRequest(() =>
    API.get(
      `restaurant/${restaurant_id}/delivery-conditions/postcodes/find`,
      withParams(params)
    )
  )

export const getDeliveryPostcodeFirstParts = (restaurant_id) =>
  handleRequest(() =>
    API.get(`restaurant/${restaurant_id}/delivery-conditions/postcodes/first-parts`)
  )

export const getDeliveryPostcodeSecondParts = (restaurant_id, firstPart) =>
  handleRequest(() =>
    API.get(
      `restaurant/${restaurant_id}/delivery-conditions/postcodes/second-parts/${firstPart}`
    )
  )

export const getSingleDelivaryCondation = id =>
  handleRequest(() => API.get(`restaurant/delivery-conditions/${id}`))

export const createDelivaryCondation = data =>
  handleRequest(() => API.post(`restaurant/delivery-conditions`, data))

export const updateDelivaryCondation = (id, data) =>
  handleRequest(() => API.put(`restaurant/delivery-conditions/${id}`, data))

export const deleteDelivaryCondation = id =>
  handleRequest(() => API.delete(`restaurant/delivery-conditions/${id}`))

export const toggleDelivaryCondation = id =>
  handleRequest(() => API.put(`restaurant/delivery-conditions/${id}/toggle-status`))

export const getDeliveryCoverageSummary = restaurant_id =>
  findDelivaryPostcodes(restaurant_id, {})
